@if (data) {
  <div class="dialog-container">
    <form (submit)="onSubmit()">
      <app-template-text [control]="control" />
      <button mat-stroked-button [disabled]="control.invalid" type="submit">{{ "DIALOG.BOOKMARKS.SAVE" | translate }}</button>
    </form>
  </div>
}
